import React from 'react';
import BackButton from '../_Shared/BackButton';




function UsedUnitsOver60Days() {
    return (
        <div className="container">
            <div className="jumbotron">
                <div className="col-sm-10 mx-auto">
                    <BackButton /><h2 className="text-center">Used Units Over 60 Days</h2>
                    <div className="row">
                        <div className="col-md-12 col-sm-12">
                            <div className="card text-white rounded formula-definition">
                                <div className="card-header text-center" id="formula">Formula Definition: No Used Units Over 60 Days 
                                 <br />
                                    Guide : 0
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}




export {
    UsedUnitsOver60Days
}